import React from 'react';
import ProductCardImageStyled from './bundle.esm2.js';
import Image from '../../../ui/Image/bundle.esm.js';
import Carousel from '../../../ui/Carousel/bundle.esm.js';

const ProductCardImage = (props) => {
  const { className, product, errorImage, height = 168, width = 168 } = props;
  const { animated, infinite, alt, controls, pagination, scrollSpeed } = props;
  const { initialSlide, nextIcon, prevIcon, onChange, fallbackImage } = props;
  const { draggable } = props;
  const { name, images } = product;
  const localFallbackImage = fallbackImage != null ? fallbackImage : "https://res.cloudinary.com/dovstvjim/image/upload/v1627933617/Propeller/product_false_kxyniy.jpg";
  return /* @__PURE__ */ React.createElement(ProductCardImageStyled, {
    className: `ProductCardImage ${className}`
  }, images.length > 0 ? /* @__PURE__ */ React.createElement(Carousel, {
    className: "ProductCardImage__carousel",
    animated,
    infinite,
    controls,
    pagination,
    scrollSpeed,
    initialSlide,
    nextIcon,
    prevIcon,
    onChange,
    draggable
  }, images.map((image, index) => /* @__PURE__ */ React.createElement(Image, {
    key: index,
    className: "ProductCardImage__image",
    alt: alt != null ? alt : name,
    config: { width, height },
    image,
    errorImage,
    width,
    height,
    draggable: "false"
  }))) : null, !images.length ? /* @__PURE__ */ React.createElement(Image, {
    className: "ProductCardImage__image",
    alt: alt != null ? alt : name,
    config: { width, height },
    image: localFallbackImage,
    errorImage,
    width,
    height,
    draggable: "false"
  }) : null);
};
ProductCardImage.defaultProps = {
  className: "",
  width: 168,
  height: 168,
  controls: false,
  pagination: false
};

export { ProductCardImage as default };
//# sourceMappingURL=bundle.esm.js.map
